define('modules/lp_integration/models/integration_status',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    defaults: {
      email: true,
      mdirector: false,
      post: false,
      correodirect: false
    },
    url: function(){
      return [config.apiHost, "pages", this.pageId, "integration"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    }
  });
});

